import HtmlContent from '../HtmlContent';

const CoreImage = ({ block }) => <HtmlContent html={block.innerHTML} />;
export default CoreImage;
